/* ManageInstructionsComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ManageInstructionsRenderer");
const InstructionsFeed = require("./PagingInstructionsFeed");
const ContentTypeComponent = require("./column_renderers/contentType/ContentTypeComponent");
const ActionsComponent = require("./column_renderers/links/LinksComponent");
// Decommissioned column renderers - not used anymore
// const EnabledComponent = require("./column_renderers/enable/InstructionEnableComponent");
// const FilenameComponent = require("./column_renderers/filename/FilenameComponent");

class ManageInstructionsComponent extends EventEmitter {
    constructor(context) {
        super();
        this._parentView = context;
        this._platformEntity = _.get(this._parentView, "_odmOsPlatform");
        this._storageFactory = _.get(this._parentView, "_storageFactory");
        this._gameEditor = _.get(this._parentView, "_gameEditor");
        this._logger = _.get(this._parentView, "logger");
        this._activeOrgId = this._gameEditor._activeOrgId;
        this._userSession = this._gameEditor._userSession;

        this._renderer = new Renderer(this);
        this._key = "manage-instructions";
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        // Add event listeners here if needed
    }

    _unregisterListeners() {
        // Remove event listeners here if needed
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get pagingFeed() {
        return this._instructionsFeed;
    }

    shutdown() {
        this._unregisterListeners();

        const shutdowns = [
            this._renderer.shutdown(),
            _.isUndefined(this._instructionsFeed)
                ? Promise.resolve()
                : this._instructionsFeed.shutdown(),
            _.isUndefined(this._userGridData) ? Promise.resolve() : this._userGridData.shutdown(),
        ];

        return Promise.all(shutdowns).then(
            () => {
                // Clean up renderer
                this._renderer = undefined;

                // Clean up feed
                this._instructionsFeed = undefined;

                // Clean up storage
                this._userGridData = undefined;
                this._storageFactory = undefined;

                // Clean up entity references
                this._platformEntity = undefined;

                // Clean up editor references
                this._gameEditor = undefined;
                this._parentView = undefined;

                // Clean up other properties
                this._key = undefined;
                this._activeOrgId = undefined;
                this._userSession = undefined;

                // Clean up logger last
                this._logger = undefined;
            },
            (err) => {
                if (this._logger) {
                    this._logger.warn({error: err}, "ManageInstructionsComponent.shutdown() error");
                }
            }
        );
    }

    get columnConfig() {
        return {
            // enabled: {
            //     label: "Enabled",
            //     width: 70,
            //     priority: 1,
            //     entityColumn: true,
            //     sortable: false,
            //     context: {
            //         platformId: this._platformEntity.getId(),
            //         platformDetails: this._parentView,
            //         platformEntityDef: this._parentView._OdmOsPlatformEntity,
            //     },
            //     columnRendererComponent: EnabledComponent,
            // },
            filename: {
                sort: "asc",
                label: "Name",
                width: 200,
                priority: 2,
            },
            contentType: {
                label: "Type",
                width: 100,
                priority: 3,
                entityColumn: true,
                columnRendererComponent: ContentTypeComponent,
            },
            action: {
                label: "Actions",
                width: 75,
                priority: 4,
                entityColumn: true,
                sortable: false,
                isLockedRight: true,
                context: {gameEditor: this._gameEditor},
                columnRendererComponent: ActionsComponent,
            },
        };
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    whenModelIsReady() {
        return Promise.resolve().then(() => {
            return this._startInstructionsFeed();
        });
    }

    async _startInstructionsFeed() {
        return this._storageFactory.whenStorageIsReady().then(() => {
            this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
                "entity_grid_gl",
                this._key
            );

            const userSorting = this._userGridData.getSorting() || {};
            const patchedSorting = this._patchSorting(userSorting);

            this._instructionsFeed = new InstructionsFeed({
                activeOrgId: this._activeOrgId,
                feedKey: this._key + "_feed",
                userSession: this._userSession,
                entityDef: this._platformEntity,
                columnConfig: this.columnConfig,
                additionalDataFields: ["contents"],
                sort: patchedSorting,
            });

            return this._instructionsFeed.whenFeedReady();
        });
    }

    _patchSorting(sorting) {
        // add second sorting order by filename
        const patchedSorting = Object.assign({}, sorting);
        if (
            patchedSorting &&
            Object.keys(patchedSorting).length === 1 &&
            !patchedSorting.filename &&
            this.columnConfig.filename
        ) {
            patchedSorting.filename = 1;
        }
        return patchedSorting;
    }

    _onUserSorted(sortData) {
        let sort = {};

        const sortCriteria =
            this.columnConfig[sortData.sortColumn].valuePath ||
            this.columnConfig[sortData.sortColumn].path ||
            sortData.sortColumn;

        sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        sort = this._patchSorting(sort);

        this._instructionsFeed.setSort(sort);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ManageInstructionsComponent;
